<div [formGroup]="treatmentFormGroup">
  <div [formGroup]="sprayBoothStudyInstructions" *ngIf="existingTreatmentFormData.sprayBoothStudyInstructions?.length > 0">
    <div formArrayName="sprayEventDaysAfterPlantingList">
      <hr>
      <h5>Spray Booth Study Instructions</h5>
      <app-vertical-tab-group>
        <app-vertical-tab *ngFor="let sprayStudy of existingTreatmentFormData.sprayBoothStudyInstructions; let i=index" [title]="'Spray ' + (sprayStudy.sprayEventNumber)"
                          [hasError]="sprayEventDaysAfterPlantingList.at(i).invalid">

          <div class="px-2 px-md-3">
            <div class="form-group row mb-2">
              <div class="col-sm-6">
                <label class="control-label">Application Volume:</label>
                <span class="form-control-static">{{ sprayStudy.applicationVolume }}</span>
              </div>
              <div class="col-sm-6">
                <label class="control-label custom-margin"
                       [ngClass]="{'text-danger font-weight-bold': sprayEventDaysAfterPlantingList.at(i).value === null || sprayEventDaysAfterPlantingList.at(i).value === '' || sprayEventDaysAfterPlantingList.at(i).value < 0}">
                  Application Date:
                </label>
                <div [class.has-error]="sprayEventDaysAfterPlantingList.at(i).invalid"
                     style="display: inline-flex; align-items: center; flex-direction: column;">
                  <div style="display: flex; align-items: center;">
                    <input type="number"
                           class="form-control"
                           style="width: 80px; margin-right: 6px;"
                           [formControlName]="i"
                           [ngClass]="{'is-invalid': sprayEventDaysAfterPlantingList.at(i).value < 0}" />
                    <small style="white-space: nowrap;"
                           [ngClass]="{'text-danger font-weight-bold': sprayEventDaysAfterPlantingList.at(i).value === null || sprayEventDaysAfterPlantingList.at(i).value === '' || sprayEventDaysAfterPlantingList.at(i).value < 0}">
                      days after planting
                    </small>
                  </div>
                  <div class="text-muted mt-1" *ngIf="getFormattedDate(i)">
                    {{ getFormattedDate(i) }}
                  </div>
                </div>
              </div>
            </div>

            <div class="form-group row mb-2">
              <div class="col-sm-6">
                <label class="control-label">Application Timepoint:</label>
                <span class="form-control-static">{{ sprayStudy.applicationTimepoint }}</span>
              </div>
            </div>
          </div>
          <div class="form-group row mb-2">
            <div class="col-sm-6">
              <div>
                <div style="text-align:center">
                  <label>Actives</label>
                </div>
                <accordion class="custom-width">
                  <accordion-group *ngFor="let active of sprayStudy.actives" [isOpen]="false" heading="{{active.herbicideTradeName + ' (' + active.factsid + ')'}}">
                    <div class="form-group row mb-2 text-center">
                      <div>
                        <label class="control-label">Active Ingredient:</label>
                        <span class="form-control-static">{{ active.activeIngredient }}</span><br />
                        <label class="control-label">Concentration:</label>
                        <span class="form-control-static">{{active.concentrationValue + ' ' + active.concentrationUnit}}</span><br />
                        <label class="control-label">Rate:</label>
                        <span class="form-control-static">{{active.rateValue + ' ' + active.rateUnit}}</span><br />
                        <label class="control-label">Relative Field Rate:</label>
                        <span class="form-control-static">{{active.relativeFieldRate}}x</span>
                      </div>
                    </div>

                  </accordion-group>
                </accordion>
              </div>
            </div>
            <div class="col-sm-6">
              <div>
                <div style="text-align:center">
                  <label>Adjuvants</label>
                </div>
                <accordion class="custom-width">
                  <accordion-group *ngFor="let adjuvant of sprayStudy.adjuvants" [isOpen]="false" heading="{{adjuvant.adjuvantName}}">
                    <div class="form-group row mb-2 text-center">
                      <div>
                        <label class="control-label">Rate:</label>
                        <span class="form-control-static">{{adjuvant.adjuvantValue + ' ' + adjuvant.adjuvantUnit}}</span>
                      </div>
                    </div>
                  </accordion-group>
                </accordion>
              </div>
            </div>
          </div>
        </app-vertical-tab>
      </app-vertical-tab-group>
    </div>
  </div>
</div>



// WEBPACK FOOTER //
// F:/PHAZP5152IS01-2/_work/98/s/src/app/view-request/request-planning-modal/request-planning-treatment-spray/request-planning-treatment-spray.component.html